const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M10 6L8.59 7.41L13.17 12l-4.58 4.59L10 18l6-6z\"/>"
};
exports.__esModule = true;
exports.default = data;
